import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Pill, PILL_BACKGROUND_COLOR, PILL_CONTENT_TYPE, PILL_SIZE} from '@Components/pill-legacy';
import {Text, TextSize} from '@Components/text';
import type {CreditPackListItemProps} from '@Components/checkout-flow/components/credit-pack-list-item/credit-pack-list-item.types';
import styles from './credit-pack-list-item.module.scss';

export function CreditPackListItem({creditPack, formattedPrice, formattedPricePerCredit, isPopular, showsPopularLabel, isSelected, onSelect}: CreditPackListItemProps): ReactElement {
  const getPopularPill = (): ReactElement | null => {
    if (!isPopular) {
      return null;
    }
    return (
      <Pill
        background={PILL_BACKGROUND_COLOR.NONE}
        className={styles.popularPill}
        size={PILL_SIZE.XSMALL}
        content={{
          type: PILL_CONTENT_TYPE.HYBRID,
          icon: 'icon-fire',
          iconColor: 'ct-premium-primary',
          iconClasses: '_unmargin',
          gap: showsPopularLabel ? undefined : 0,
          text: showsPopularLabel ? window.i18next.t('pmwjs_popular') : '',
          textSize: TextSize.SM,
          textColor: 'ct-premium-primary',
          textClasses: showsPopularLabel ? 'spacing-m-l-1' : '',
          isBold: true,
        }}
      />
    );
  };

  const getPricePerCredit = (): ReactElement | null => {
    if (formattedPricePerCredit === null) {
      return null;
    }
    return <Text val={formattedPricePerCredit} size={TextSize.SM} className={styles.pricePerCredit} />;
  };

  return (
    <li>
      <ClickableDiv
        onClick={onSelect}
        className={`${styles.item} ${isSelected ? styles.selected : ''}`}
        role="radio"
        aria-checked={isSelected}
        aria-label={`${creditPack.name} ${formattedPrice}`}
      >
        <div className={styles.iconBox}>
          <Icon icon="icon-flash" size={IconSize.SIZE_ICON_16} className={styles.icon} ariaHidden />
        </div>
        <div className={styles.info}>
          <div className={styles.nameRow}>
            <Text val={creditPack.name} size={TextSize.LG} bold className={styles.name} />
            {getPopularPill()}
          </div>
          {getPricePerCredit()}
        </div>
        <Text val={formattedPrice} size={TextSize.LG} bold className={styles.price} />
      </ClickableDiv>
    </li>
  );
}
